import React, { useEffect, useState } from 'react'
import Header from '../../comps/Header'
import Footer from '../../comps/Footer'
import PageMainBanner from '../../comps/PageMainBanner'
import { Link, useNavigate } from 'react-router-dom'
import { get_knowledge_centres_data, get_main_banner_section } from '../../api/Global'
import { IMG_BASE_URL } from '../../config/Base_Url_Config'
import { Link2 } from 'lucide-react'
import More_Hosting from '../more_hosting/More_Hosting'

const Knowledge = () => {
      const navigate = useNavigate();
      const [get_banner_list, set_Banner_List] = useState([]);
      const [knowledge, setKnowledge] = useState([]);

      // <------------- handle date and time formate -------------->
      const formatDate = (dateString) => {
            const date = new Date(dateString);
            return date.toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' });
      };

      // <--------- fetch the knowledge centers data -------------->
      useEffect(() => {
            const handle_get_knowledge = async () => {
                  try {
                        const response = await get_knowledge_centres_data();
                        setKnowledge(response?.data?.data?.knowledge_centres)
                  }
                  catch (error) {
                        console.log("error during call the knowledge centers data", error)
                  }
            }
            handle_get_knowledge();
      }, [])

      // <----------- render the main banner section ---------->
      useEffect(() => {
            const handle_get_main_banner_section = async () => {
                  try {
                        const response = await get_main_banner_section();
                        set_Banner_List(response?.data?.data?.banners)
                  } catch (error) {
                        console.log("error", error)
                  }
            }
            handle_get_main_banner_section();
      }, [])
      return (
            <>
                  <Header />
                  <PageMainBanner heading="Blogs List" title={get_banner_list?.knowledge_center_title} para={get_banner_list?.knowledge_center_description} image={get_banner_list?.knowledge_center_image ? `${IMG_BASE_URL}/${get_banner_list?.knowledge_center_image}` : "assets/images/blogs.png"} />
                  <section className="relative py-10 md:py-24">
                        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-transparent" />
                        {
                              knowledge?.map((knowledge_center_result) => {
                                    return (
                                          <div className="mx-auto max-w-7xl px-4 lg:px-8">
                                                <div className="relative group mb-6">
                                                      <div className="relative bg-gray-50/50 rounded-xl p-3 md:p-6 border border-blue-900/10">
                                                            <div className="md:flex gap-8">
                                                                  <div className="relative w-46 h-48 md:h-72 md:w-80 rounded-lg overflow-hidden">
                                                                        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-lg" />
                                                                        <img src={`${IMG_BASE_URL}/${knowledge_center_result?.image}`} alt="Post" className="w-full h-full object-cover rounded-lg" />
                                                                  </div>
                                                                  <div className="flex max-w-3xl flex-col justify-center items-start">
                                                                        <div className="sm:flex md:flex items-center gap-4 mb-3 mt-3 md:mt-0"><span className="px-3 py-1 text-sm text-blue-400 bg-blue-500/10 rounded-full">Uncategorized</span>
                                                                              <span className="text-sm text-gray-400"><i className="fa-regular fa-clock text-blue-500 mr-2" />{formatDate(knowledge_center_result?.created_at)}</span>
                                                                              {/* <span className="text-sm text-gray-400"><i className="fa-regular fa-comment text-blue-500 mr-2" /> 20</span> */}
                                                                        </div>
                                                                        <h2 className="text-2xl font-bold mb-4 line-clamp-2">{knowledge_center_result?.title}</h2>
                                                                        <p className="text-gray-400 line-clamp-3 mb-6">{knowledge_center_result?.description}</p>
                                                                        <Link to={`/knowledge-center-detail/${knowledge_center_result?.id}`}
                                                                              className="rounded-lg bg-gradient-to-r from-blue-800 to-blue-600 px-6 py-3.5 text-sm font-semibold 
                                                                        text-white shadow-sm hover:from-blue-700 hover:to-blue-500 focus-visible:outline focus-visible:outline-2
                                                                         focus-visible:outline-offset-2 focus-visible:outline-blue-600 transition-all duration-200 text-center">
                                                                              Read More... </Link>
                                                                  </div>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    )
                              })
                        }

                  </section>
                  {/*  */}
                  <More_Hosting/>
                  <Footer />
            </>
      )
}

export default Knowledge